import React from 'react';
import PropTypes from 'prop-types';
var Gradient = function Gradient(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "ui-gradient"
  }, children);
};
Gradient.propTypes = {
  /**
   * children for content inside
   */
  children: PropTypes.node
};
Gradient.defaultProps = {
  children: []
};
export default Gradient;